import { UserCheck, Wallet, Award, TrendingDown } from "lucide-react";

const DIFFERENTIALS = [
    {
        icon: UserCheck,
        title: "Você fala direto com o contador",
        description: "Sem fila e sem robô: você fala com quem entende da sua empresa.",
    },
    {
        icon: Wallet,
        title: "Mensalidade justa, sem surpresas",
        description: "Preço claro desde o primeiro dia, sem sustos no fim do mês.",
    },
    {
        icon: Award,
        title: "Experiência comprovada",
        description: "Escritório registrado no CRC 2SP051732/O-6, com histórico comprovado.",
    },
    {
        icon: TrendingDown,
        title: "Redução legal de impostos",
        description: "Estudamos seu enquadramento para você pagar só o imposto devido.",
    },
];

export const Differentials = () => {
    return (
        <section id="diferenciais" data-testid="differentials-section" className="py-20 lg:py-32 bg-[#F8FAFC]">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="max-w-2xl reveal-on-scroll">
                    <p className="eyebrow text-xs font-bold uppercase tracking-[0.2em] text-blue-900" data-testid="differentials-eyebrow">
                        Por que a WBS
                    </p>
                    <h2 className="mt-4 text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900" data-testid="differentials-title">
                        Contabilidade do jeito que deveria ser: próxima e transparente
                    </h2>
                </div>
                <div className="mt-12 grid sm:grid-cols-2 gap-6" data-testid="differentials-list">
                    {DIFFERENTIALS.map((item) => (
                        <div
                            key={item.title}
                            className="group glass-card rounded-2xl p-7 flex gap-5 transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg"
                            data-testid={`differential-${item.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                        >
                            <span className="flex items-center justify-center w-12 h-12 rounded-lg bg-slate-900 text-amber-400 shrink-0 transition-transform duration-300 group-hover:scale-110">
                                <item.icon className="w-6 h-6" />
                            </span>
                            <div>
                                <h3 className="text-lg font-semibold text-slate-900">{item.title}</h3>
                                <p className="mt-1 text-sm text-slate-600 leading-relaxed">{item.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
